import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as ProfileItemActivitiesActions from './profile-item-activities.actions'
import { ProfileItemActivitiesEntity } from './profile-item-activities.models'

export const PROFILE_ITEM_ACTIVITIES_FEATURE_KEY = 'profileItemActivities'

export interface ProfileItemActivitiesState extends EntityState<ProfileItemActivitiesEntity> {
  selectedId?: string | number // which ProfileItemActivities record has been selected
  loaded: boolean // has the Activities list been loaded
  error?: any // last known error (if any)
}

export interface ActivitiesPartialState {
  readonly [PROFILE_ITEM_ACTIVITIES_FEATURE_KEY]: ProfileItemActivitiesState
}

export const activitiesAdapter: EntityAdapter<ProfileItemActivitiesEntity> =
  createEntityAdapter<ProfileItemActivitiesEntity>({
    selectId: (activity: ProfileItemActivitiesEntity) => activity.item.uuid,
  })

export const initialState: ProfileItemActivitiesState = activitiesAdapter.getInitialState({
  // set initial required properties
  loaded: false,
})

const profileItemActivitiesReducer = createReducer(
  initialState,
  on(ProfileItemActivitiesActions.loadProfileItemActivities, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(ProfileItemActivitiesActions.loadProfileItemActivitiesSuccess, (state, { activities }) =>
    activitiesAdapter.setAll(activities, { ...state, loaded: true }),
  ),
  on(ProfileItemActivitiesActions.loadProfileItemActivitiesFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: true,
  })),
  on(ProfileItemActivitiesActions.syncProfileItemActivityFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: true,
  })),
  on(ProfileItemActivitiesActions.loadProfileItemActivityVolunteer, (state) => ({
    ...state,
    loaded: false,
  })),
  on(ProfileItemActivitiesActions.loadProfileItemActivityVolunteerSuccess, (state) => ({
    ...state,
    loaded: true,
  })),
  on(ProfileItemActivitiesActions.addProfileItemActivity, (state, { activity }) =>
    activitiesAdapter.addOne(activity, state),
  ),
  on(ProfileItemActivitiesActions.updateProfileItemActivity, (state, action) =>
    activitiesAdapter.updateOne(action.update, state),
  ),
  on(ProfileItemActivitiesActions.deleteProfileItemActivity, (state, action) =>
    activitiesAdapter.removeOne(action.uuid, state),
  ),
  on(ProfileItemActivitiesActions.updateSelectedProfileItemActivityId, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(ProfileItemActivitiesActions.clearSelectedProfileItemActivityId, (state) => ({
    ...state,
    selectedId: '',
  })),
  on(ProfileItemActivitiesActions.clearProfileItemActivities, (state) => ({
    ...initialState,
    selectedId: state.selectedId,
  })),
)

export function reducer(state: ProfileItemActivitiesState | undefined, action: Action) {
  return profileItemActivitiesReducer(state, action)
}
